module.exports = __webpack_public_path__ + "assets/diners-club-bbf261.svg";